import { on, createActionGroup, props, emptyProps } from '@ngrx/store';

import Quill, { Delta } from 'quill';

import { QuillTemplate, QuillTemplateLocation } from '../../../generated/graphql.generated';
import { BrandingState } from '../../state/branding.store';

import { TemplatesActions } from './templates.store';


export const brandingTemplatesReducers = [
  on(TemplatesActions.templateCreated, (state: BrandingState, { template }) => ({
    ...state,
    templates: [template, ...(state.templates || [])],
  })),
  on(TemplatesActions.templateUpdated, (state: BrandingState, { template: updatedTemplate }) => {
    const updatedTemplates = (state.templates || []).map((t) => {

        // Update the matched template
      if (t.id === updatedTemplate.id) {
        return { ...t, ...updatedTemplate };
      }

      // If updated template is default, unset isDefault for others in the same location
      if (
        updatedTemplate.isDefault &&
        updatedTemplate.location &&
        t.location === updatedTemplate.location
      ) {
        return { ...t, isDefault: false };
      }

      return t;
    });

    return {
      ...state,
      templates: updatedTemplates,
    };
  }),
  on(TemplatesActions.templateDeleted, (state: BrandingState, { id }) => ({
    ...state,
    templates: (state.templates || []).filter((t) => t.id !== id),
  })),
];
